import "babel-polyfill";
import React from 'react';
import { Provider } from 'react-redux';
import { render } from 'react-dom';
import { Router, browserHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import * as Sentry from '@sentry/browser';

Sentry.init({
    dsn: __SENTRY_DSN__,
    environment: __DEPLOY_ENV__,
});

import './utils/array.prototype.except';
import './utils/string.prototype.limit';
import './utils/string.prototype.capitalise';
import 'rxjs';
import createStore from './redux/create';
var store = createStore();

var { dispatch } = store;
import loadAuthFromLocalStorage from './auth/LoadAuthFromLocalStorage';
loadAuthFromLocalStorage(dispatch);
import { loadTags } from './reducers/tags';
import makeRoutes from './routes';

import * as ClientActions from './actions/ClientActions';

if (store.getState().auth.loggedIn){    
    store.dispatch(ClientActions.loadUsers());
    store.dispatch(loadTags());
    store.dispatch(ClientActions.loadRecentlyViewedFromLocalStorage());
}

// syncHistoryWithStore is causing error: Unexpected key "theme" found in preloadedState argumen
var history = syncHistoryWithStore(browserHistory, store);

const routes = makeRoutes(store);

import { logout } from './auth/AuthActions';
window.addEventListener('logoutUnAuthorisedUser', (e) => {
    store.dispatch(
        logout(e.detail)
    );
});


class EntryPoint extends React.Component {
    render() {
        return (
            <Provider store={store} key="provider">
                <Router history={history}>
                    {routes}
                </Router>
            </Provider>
        );
    }
}

render(
    <EntryPoint />,
    document.getElementById("root")
);



// WEBPACK FOOTER //
// ./app/main.js